module.exports = __webpack_public_path__ + "static/media/Account Setup Complete Icon.f7c78a4a.svg";